// extracted by mini-css-extract-plugin
export var alertIcon = "_uk-0";